import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const fullscreenModalHeader = css`
  -webkit-app-region: drag;
  height: 60px;
  border-bottom: 1px solid ${theme.colors.neutral50};
  padding: ${theme.spacing(2, 6)};
`;

export const fullscreenModalHeaderTitle = css`
  margin: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const fullscreenModalHeaderSubtitle = css`
  display: block;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
